import type { IProduct } from '@rogue/universal'

const TWENTYFIVE_BY_4 = 100
const FIFTYFIVE_BY_4 = 200
const TAPE = 160
const TILE = 4

export function calculateFlooringNeeded(totalSquareFeet: number, rolls: IProduct[]): IProduct[] {
  const smallRolls = Math.max(1, Math.ceil(totalSquareFeet / TWENTYFIVE_BY_4))
  const bigRolls = Math.max(1, Math.ceil(totalSquareFeet / FIFTYFIVE_BY_4))
  const RG0009 =  Math.max(1, Math.ceil(totalSquareFeet / TAPE))

  const smallLabel = `${smallRolls} Roll${smallRolls === 1 ? '' : 's'}, 25’ long`
  const bigLabel = `${bigRolls} Roll${bigRolls === 1 ? '' : 's'}, 50’ long`

  return rolls.map(roll => ({
    ...roll,
    qty   : roll.attributes.flooring_length === '25\'' ? smallRolls : bigRolls,
    label : roll.attributes.flooring_length === '25\'' ? smallLabel : bigLabel,
    sqft  : roll.attributes.flooring_length === '25\'' ? smallRolls * TWENTYFIVE_BY_4 : bigRolls * FIFTYFIVE_BY_4,
    RG0009,
  }))
}

export function calculateTilesNeeded(totalSquareFeet: number): number {
  return Math.max(Math.ceil(totalSquareFeet / TILE), 8)
}
